import { Logo } from "@/components/logo";
import { Utensils } from "lucide-react";

const Loading = () => {
  return (
    <div className="relative h-screen w-full overflow-hidden bg-gradient-to-b from-emerald-50 to-emerald-100 dark:from-slate-950 dark:to-slate-900">
      {/* Static food pattern background */}
      <div className="absolute inset-0 opacity-5">
        <div className="grid grid-cols-4 md:grid-cols-6 gap-8">
          {[...Array(24)].map((_, i) => (
            <div
              key={i}
              className="flex items-center justify-center p-4"
            >
              <Utensils className="h-8 w-8 text-emerald-600 dark:text-emerald-400" />
            </div>
          ))}
        </div>
      </div>

      {/* Central loading content */}
      <div className="relative flex h-full flex-col items-center justify-center gap-8">
        <div className="animate-fade-in">
          <div className="text-3xl font-bold text-emerald-600 dark:text-emerald-400">
            <Logo></Logo>
          </div>
        </div>

        {/* Loading indicator */}
        <div className="flex items-center gap-2">
          <div className="flex gap-2">
            {[...Array(3)].map((_, i) => (
              <div
                key={i}
                className="h-2 w-2 rounded-full bg-emerald-500 dark:bg-emerald-400 animate-bounce"
                style={{ animationDelay: `${i * 0.2}s` }}
              />
            ))}
          </div>
          <span className="text-sm font-medium text-slate-700 dark:text-slate-300">
            Preparing your experience
          </span>
        </div>

        {/* Food-related tagline */}
        <p className="text-center text-sm text-emerald-600 dark:text-emerald-400">
          Discovering Morocco's finest flavors
        </p>
      </div>

      {/* Add subtle pulse animation to background */}
      <div className="absolute inset-0 bg-gradient-radial from-emerald-200/20 to-transparent dark:from-emerald-800/10 animate-pulse" />

      {/* Footer with subtle shadow */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-emerald-100/80 to-transparent dark:from-slate-900/80"></div>
    </div>
  );
};

export default Loading;